import React, { Component, BaseSyntheticEvent, ChangeEvent } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import GridTemplateConfigurationController from '../grid-template-config.controller';
import { TemplateSFObjectStore } from '../../../../store/models/template-object.model';
import { observer } from 'mobx-react';
import { Utility } from '../../../../common/utility';
import { CQCombobox, generateComboboxOptions, IOption, CQCheckbox } from '../../../../common/cq-inputs';
import { CQAPIService } from '../../../../services/http-api.service';

class GridFieldsToDisplay extends Component<any, any>{
    private utility: Utility;
    private templateConfigCtrl: GridTemplateConfigurationController;
    constructor(props: any) {
        super(props);
        this.utility = new Utility();
        this.templateConfigCtrl = new GridTemplateConfigurationController();
        this.state = {
            toggleFieldToDisplay: false,
            toggleReferenceFieldToDisplay: false,
            isReferenceInputFieldVisible: true,
            fieldsToDisplay: [],
            isObjectListOpen: false,
            referenceFieldArray: [],
            fieldToDiaplayObjVal: '',
            fieldToDisplayText: '',
            fieldToDisplayRefObj: '',
            displayFields: [],
            fieldToDisplay: '',
            customLabel: '',
            customGroup: '',
            referenceFieldToDisplayText:'',
            disableSaveButton:false,
            fieldType:'',
            inputBoxSize: 0,
            resultValue:[],
            isTextAreaSizeManual: false,
        };
    }

    componentDidMount() {
        const viewSourceComponentConfig = CQMasterDataStore.GridObject.gridComponentConfigView;
        if (Object.keys(viewSourceComponentConfig).length > 0) {
            this.setState({
                objectFields: TemplateSFObjectStore.standardObjectFields,
                fieldsToDisplay: viewSourceComponentConfig.hasOwnProperty('fieldsToDisplay') ? viewSourceComponentConfig.fieldsToDisplay : [],
                displayFields: viewSourceComponentConfig.hasOwnProperty('displayFields') ? viewSourceComponentConfig.displayFields : [],
                toggleFieldToDisplay: viewSourceComponentConfig.hasOwnProperty('fieldsToDisplay') && viewSourceComponentConfig.fieldsToDisplay.length > 0 ? true : false
            });
        }
    }

    componentWillReceiveProps() {
        const viewSourceComponentConfig = CQMasterDataStore.GridObject.gridComponentConfigView;
        if (Object.keys(viewSourceComponentConfig).length > 0) {
            this.setState({
                objectFields: TemplateSFObjectStore.standardObjectFields,
                fieldsToDisplay: viewSourceComponentConfig.hasOwnProperty('fieldsToDisplay') ? viewSourceComponentConfig.fieldsToDisplay : [],
                displayFields: viewSourceComponentConfig.hasOwnProperty('displayFields') ? viewSourceComponentConfig.displayFields : [],
                toggleFieldToDisplay: viewSourceComponentConfig.hasOwnProperty('fieldsToDisplay') && viewSourceComponentConfig.fieldsToDisplay.length > 0 ? true : false
            });
        }
    }

    /**
     * check of the given data is present in given displayField array
     * @param data value which need to be compared
     * @param compareTo array where data is checked to exist or not
     * @returns true if data exist in compareTo else false
     */
    isDataAlreadyPresent = (data: any, compareTo: any[]) => {
        const type = typeof data;
        let isPresent = false;
        for(const value of compareTo) {
            if(isPresent) {
                break;
            }

            if(type === 'string' && typeof value === 'string') {
                isPresent = data === value;
            } else if(type === 'object' && typeof value === 'object') {
                const key1 = Object.keys(value)[0];
                const key2 = Object.keys(data)[0];
                isPresent = key1 === key2 && value[key1] === data[key2];
            }
        }

        return isPresent;
    }

    /**
     * update the state of an application
     * @param state state of an application
     * @param fieldToDisplay record that need to be removed
     * @param cb callback function
     */
    updateState = (state: any, fieldToDisplay?: any, cb?: Function) => {
        this.setState({
            ...this.state, 
            ...state
        }, () => {
            if(typeof cb === 'function') {
                cb();
            }

            const { fieldsToDisplay, displayFields } = this.state;
            let viewSourceComponentConfig = { 
                ...this.props.viewSourceComponentConfig, 
                fieldsToDisplay: fieldsToDisplay, 
                displayFields: displayFields 
            };
            
            //updates ruleElements and gridObjects
            if(fieldToDisplay) {
                this.props.updateViewSource(viewSourceComponentConfig, fieldToDisplay);
            } else {
                this.props.updateViewSource(viewSourceComponentConfig);
            }
            
            let displayFieldsArray = Array.from(new Set(fieldsToDisplay));
            //updates fields
            this.templateConfigCtrl.updateFieldValue('fields', displayFieldsArray, this.props.selectedTemplateName);
        });
    }

    handleBlur = (e: BaseSyntheticEvent) => {
        if (e.target.explicitOriginalTarget &&
            e.target.explicitOriginalTarget === e.target.originalTarget) {
            return;
        }
        if (this.state.isObjectListOpen || this.state.toggleReferenceFieldToDisplay) {
            setTimeout(() => {
                this.setState({isObjectListOpen:false,toggleReferenceFieldToDisplay:false})
            }, 300);
        }
    };

    generateGroupPlaceholder = (customLabel: string) => {
        let label = customLabel.toLowerCase().split(' '); 
        label = label.map((text: string, index: number) => {
            if(index !== 0){
                text = text.split('').map((t: string, key: number) => {
                    if(key===0){
                        t= t.toUpperCase();
                    }
                    return t;
                }).join('');
            }
            return text;
        });
        this.setState({ customGroup: `${label.join('')}Group` });
    }

    displayFieldInPill = (field:any) => {
        const indexForDisplayFields = this.state.fieldsToDisplay.indexOf(field);
        let fieldOfDisplayFields = this.state.displayFields[indexForDisplayFields];
        if (typeof (field) === 'object') {
            const columnKey = Object.keys(fieldOfDisplayFields)[0];
            return <p>{columnKey.replace('customComponent', 'Compound Component')} : {fieldOfDisplayFields[columnKey]}</p>
        } else {
            return <p>{fieldOfDisplayFields}</p>
        }
    }

    /**
     * handle combobox input to store reference fields
     * @param actionType selected action
     * @param result event value
     */
    handleActionPerformed(actionType:any, result:any){
        {
            if(typeof result === 'string') {
                return;
            }
            
            if(actionType === 'item-selected' || actionType === 'item-cleared') {
                const tempResult = result[0];
                this.setState({ referenceFieldToDisplayText: tempResult ? tempResult.value : '' }, () => {
                    this.referenceFieldToDisplay(result[0] || '')
                });
            }
        }
    }

    /**
     * renders toggle/input field for text area fields
     */
    renderTextAreaField() {
        if (this.state.isTextAreaSizeManual) {
            return (
                <div className="slds-form-element slds-input-has-fixed-addon">
                    <input
                        type="number"
                        id="form-element-05"
                        placeholder="Enter number of lines"
                        value={this.state.inputBoxSize}
                        name="boxSize"
                        className="slds-input"
                        onChange={this.handleInputChange}
                        min="1"
                        max="20"
                    />
                    <span className="slds-form-element__addon">
                        <button className="slds-button slds-button_brand" disabled={this.state.disableSaveButton} onClick={this.handleInputSave}>Save</button>
                    </span>
                </div>
            );
        } else {
            return (
                <div className="slds-input-has-fixed-addon">
                    <CQCheckbox
                        key={this.state.isTextAreaSizeManual}
                        label=""
                        onToggleChanged={this.handleChangeCheckbox}
                        value={this.state.isTextAreaSizeManual}
                        config={{ variant: 'toggle' }}
                        customToggleLabel={{
                            toggleDisabled: 'Unchecked' ,
                            toggleEnabled: 'Checked',
                        }}
                    />
                    <label className="slds-form-element__label slds-m-left_x-small">Enter number of lines</label>
                </div>
            );
        }
    }



    onObjectSelectionDisplayFields = () => {
        let content: any;
        if(this.state.fieldToDiaplayObjVal === 'customComponent'){
            content = (
							<div className="slds-form-element">
								<div className="slds-grid slds-wrap  slds-p-bottom_x-small">
									<div className="slds-col slds-size_1-of-2 slds-p-horizontal_x-small">
										<div className="slds-form-element__control">
											<input
												type="text"
												id="form-element-03"
												placeholder="Enter Label"
												name="customLabel"
												value={this.state.customLabel}
												required={true}
												className="slds-input"
												onChange={this.fieldToDisplayTextChanged}
											/>
										</div>
									</div>
									<div className="slds-col slds-size_1-of-2 slds-p-horizontal_x-small">
										<div className="slds-form-element__control">
											<input
												type="text"
												id="form-element-04"
                                                placeholder={`Enter group name`}
                                                onFocus={() => this.generateGroupPlaceholder(this.state.customLabel)}
												name="customGroup"
												value={this.state.customGroup}
												required={true}
												className="slds-input"
												onChange={this.fieldToDisplayTextChanged}
											/>
										</div>
									</div>
								</div>
								<button
									className="slds-button slds-button_brand"
                                    disabled={this.state.customLabel === '' || this.state.customGroup === ''}
                                    onClick={this.setCustomFields}
								>
									Add
								</button>
							</div>
						);
        }else{
            if(this.state.fieldType === 'textarea'){
                content = this.renderTextAreaField()
            }else{
                content = (
                    <>
                        <CQCombobox
                            key='referenceFields'
                            config={{
                                variation: 'inline-listbox',
                                isDisabled: !this.state.isReferenceInputFieldVisible
                            }}
                            label={{
                                label: '',
                                placeholder: 'Please Reference Fields'
                            }}
                            onActionPerformed={(actionType, result) => this.handleActionPerformed(actionType, result)}
                            options={this.generateOptions(this.filterReferenceFieldToDisplayValues())}
                            limit={this.generateOptions(this.filterReferenceFieldToDisplayValues()).length}
                            value={this.state.referenceFieldToDisplayText}
                        />
                    </>
                )
            }
        }
        return content;
    }

    /**
     * generates refined combobox option
     * @param options raw options which needs to be refined for cq-combobox
     * @returns refined option suitable for cq-combobox
     */
    generateOptions = (options: any[]): IOption[] => {
        return generateComboboxOptions(
            options, 
            {
                label: 'label',
                value: 'name',
            }, (option) => {
                let resultedLabel = option.label + ' - ' + option.name;
                if(option.name === "customComponent" && option.label === "Compound Field") {
                    resultedLabel = option.label;
                }

                return resultedLabel;
            }
        );
    }

    /**
     * gives the label of the field
     * @param label raw label in format <label> - <apiName>
     * @returns <label> label of the field
     */
    getLabel = (label: string) => {
        return label.split(' - ')[0];
    }

    render() {
        const { name } = this.props.fieldInfo;
        return (
            <div className="slds-form-element">
            <div className="slds-form-element__control">
                <label className="slds-form-element__label" >{name}</label>
                <div className="slds-grid slds-gutters">
                    <div className="slds-col slds-size_1-of-2">
                        <CQCombobox
                            key='mainFields'
                            config={{
                                variation: 'inline-listbox',
                                isDisabled: false
                            }}
                            label={{
                                label: '',
                                placeholder: 'Please Select Fields'
                            }}
                            onActionPerformed={(actiontype, result) => {
                                if(typeof result === 'string') {
                                    return;
                                }
                                
                                const tempResult = result[0];
                                let fieldType = this.filterFieldToDisplayValues().find((field)=>field?.name ===  tempResult?.name);
                                this.setState({
                                    fieldToDisplayText:  tempResult ? this.getLabel(tempResult.label) : '',
                                    fieldToDiaplayObjVal: tempResult ? tempResult.value : '',
                                    fieldType: fieldType ? fieldType.type : '',
                                    resultValue: result[0]
                                }, () => {
                                    this.selectedFieldsToDisplayLeft(result[0] || '')
                                });
                            }}
                            options={this.generateOptions(this.filterFieldToDisplayValues())}
                            limit={this.generateOptions(this.filterFieldToDisplayValues()).length}
                            value={this.state.fieldToDisplayText}
                        />
                    </div>
                    <div className="slds-col slds-size_1-of-2">
                        {this.onObjectSelectionDisplayFields()}
                    </div>
                </div>
                    {this.state.toggleFieldToDisplay && <div className="slds-listbox_selection-group pills-list">
                        <ul className="slds-listbox slds-listbox_horizontal" role="listbox" aria-label="Selected Options:" aria-orientation="horizontal">
                            {
                                this.state.fieldsToDisplay.length > 0 && this.state.fieldsToDisplay.map((field: any) => {
                                    const key = Object.keys(field)[0];
                                    const fieldKey = typeof field === 'object' ? field[key] : field;
                                    return <li key={fieldKey} className="slds-listbox-item" role="presentation" draggable="true"
                                        onDragStart={(e) => this.handleDragStart(e, field)} onDrop={(e) => this.handleDrop(e, field)} onDragOver={this.handleDragOver}>
                                        <span className="slds-pill" role="option" aria-selected="true">

                                            <span
                                                className="slds-pill__label"
                                                title="Salesforce Inc."
                                                style={{ "cursor": "pointer" }}
                                                onClick={ field.hasOwnProperty('label') ? () => this.editCustomComponent(field) : undefined }
                                            >
                                                {this.displayFieldInPill(field)}
                                            </span>
                                            
                                            <span className="slds-icon_container slds-pill__remove" title="Remove" onClick={() => this.removeFromFieldToDisplay(field)}>
                                                <i className="cq-icon-close"></i>
                                            </span>
                                        </span>
                                    </li>;
                                })
                            }
                        </ul>
                    </div>
                    }
                </div>
            </div>
        );
    }

    private editCustomComponent = (row: any) => {
        CQMasterDataStore.GridObject.updateGridField(
            "selectedAction",
            "customComponent"
        );
        this.props.setCustomComponent(row);
    }

    private readonly fieldToDisplayTextChanged = (e: BaseSyntheticEvent) => {
        if(e.target.name !== ''){
            this.setState({[e.target.name]: e.target.value});
        }else{
            this.setState({ fieldToDisplayText: e.target.value });
        }
    }

    /**
     * toggle checkbox to enable manual manual textarea lines
     */
    private handleChangeCheckbox = () => {
        this.setState({ isTextAreaSizeManual: true })
    };

    /**
     * update the state based on changes in number of lines in the textarea.
     * @param event the input change event object.
     */
    handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            inputBoxSize: event.target.value,
            disableSaveButton : false
        });
    };

    /**
     * handles saving textarea lines input
     */
    handleInputSave = () => {
        if(this.state.inputBoxSize < 1 || this.state.inputBoxSize > 20){
            alert('Invalid number. Please enter a number between 1-20');
            return;
        }
        this.updateDisplayFields();
        this.setState({
            disableSaveButton: true,
            isTextAreaSizeManual: false
        });
    }

    /**
     * updates display fields based on selected value 
     */
    updateDisplayFields = () => {
        const fieldValue = this.state.resultValue;
        const label = this.getLabel(fieldValue.label);
        const fieldToDisplayArray = this.utility.createObjectDeepCopy(this.state.fieldsToDisplay);
        const displayFields = this.utility.createObjectDeepCopy(this.state.displayFields);
        //manually set number of lines in text area field
        if (this.state.isTextAreaSizeManual && this.state.fieldType === 'textarea') {
            let fieldIndex = displayFields.length - 1;
            //selected textarea field will be a String until value is manually added
            if (fieldToDisplayArray && typeof fieldToDisplayArray[fieldIndex] === 'string') {
                const textAreaDisplayField = { [label]: this.state.inputBoxSize };
                if (fieldToDisplayArray[fieldIndex] === fieldValue.name) {
                    let manualTextAreaDetails = {
                        field: fieldValue.value,
                        type: this.state.fieldType,
                        line: this.state.inputBoxSize,
                    }
                    fieldToDisplayArray[fieldIndex] = manualTextAreaDetails;
                    displayFields[fieldIndex] = textAreaDisplayField;
                }
            } else {
                if (fieldToDisplayArray[fieldIndex].hasOwnProperty('field') && fieldToDisplayArray[fieldIndex]['field'] === fieldValue.name) {
                    fieldToDisplayArray[fieldIndex]['line'] = this.state.inputBoxSize;
                    displayFields[fieldIndex][label] = this.state.inputBoxSize;
                }
            }
            this.updateState({
                referenceFieldArray: [],
                fieldToDiaplayObjVal: '',
                fieldToDisplayRefObj: '',
                fieldsToDisplay: fieldToDisplayArray,
                toggleFieldToDisplay: true,
                isReferenceInputFieldVisible: false,
                fieldToDisplayText: '',
                referenceFieldToDisplayText: '',
                displayFields,
            });
        }
    }

    private readonly referenceFieldToDisplayTextChanged = (e: BaseSyntheticEvent) => {
        if(e.target.name !== ''){
            this.setState({[e.target.name]: e.target.value});
        }else{
            this.setState({ referenceFieldToDisplayText: e.target.value });
        }
    }

    private readonly setCustomFields = () => {
        const fieldToDisplayArray = this.utility.createObjectDeepCopy(this.state.fieldsToDisplay);
        const displayFields = this.utility.createObjectDeepCopy(this.state.displayFields);
        const fieldObj = this.utility.createObjectDeepCopy(this.state.fieldToDiaplayObjVal);
        // const fieldToDisplayRefObj = this.state.fieldToDisplayRefObj;
        if(!this.isDataAlreadyPresent({[fieldObj]: this.state.customLabel}, displayFields)) {
            fieldToDisplayArray.push({ "label": this.state.customLabel, "type": fieldObj, "groupName": this.state.customGroup, "fields": [] });
            displayFields.push({[fieldObj]: this.state.customLabel});
        }
        this.updateState({
            displayFields,
            fieldsToDisplay: fieldToDisplayArray,
            toggleFieldToDisplay: true,
            fieldToDiaplayObjVal: '',
            customLabel: '',
            customGroup: '',
            fieldToDisplayText: '',
        });
    }

    private readonly filterReferenceFieldToDisplayValues = () => {
        let referenceFieldList = this.state.referenceFieldArray;
        if (this.state.referenceFieldToDisplayText !== '') {
            referenceFieldList = referenceFieldList.filter((objField: any) => {
                return objField.label.toLowerCase().includes(this.state.referenceFieldToDisplayText.toLowerCase());
            });
        }
        return referenceFieldList;
    }

    private readonly filterFieldToDisplayValues = () => {
        let objectFieldsList = 
            this.utility.createObjectDeepCopy(TemplateSFObjectStore.standardObjectFields.fields) as any[];
        objectFieldsList.unshift({name: 'customComponent', label: 'Compound Field', referenceTo: []});
        return objectFieldsList;
    }

    /**
     *
     *
     * @private
     * @memberof GridComponentFieldsToDisplay
     */
    private selectedFieldsToDisplayLeft = (fieldValue: any) => {
        if(typeof fieldValue === 'string') {
            return;
        }

        const label = this.getLabel(fieldValue.label);

        if (this.state.fieldsToDisplay.length === 10) {
            alert('You can select maximum 10 fields');
        } else {
            if (fieldValue.value === 'Id') {
                let referenceFields = [...TemplateSFObjectStore.standardObjectFields.fields];
                referenceFields = referenceFields.filter((fieldVal: any) => {
                    return fieldVal.name !== 'Id';
                });
                this.setState({
                    referenceFieldArray: referenceFields,
                    fieldToDiaplayObjVal: fieldValue.value,
                    fieldToDisplayRefObj: '',
                    fieldToDisplayOb: label,
                    isReferenceInputFieldVisible: true,
                    fieldToDisplayText: label,
                    referenceFieldToDisplayText:''
                });
            }
            else if(fieldValue.name === 'customComponent'){
                this.setState({
                    fieldToDiaplayObjVal: fieldValue.value,
                    fieldToDisplayOb: label,
                    fieldToDisplayRefObj: '',
                    isReferenceInputFieldVisible: false,
                    fieldToDisplayText: fieldValue.value,
                    referenceFieldToDisplayText:''
                });
            }
            else if (fieldValue.referenceTo.length > 0) {
                this.templateConfigCtrl.getReferenceObjectFields(fieldValue.referenceTo[0], false, true);
                this.setState({
                    referenceFieldArray: TemplateSFObjectStore.referenceObjectFields.fields,
                    fieldToDiaplayObjVal: fieldValue.value,
                    fieldToDisplayRefObj: fieldValue.relationshipName,
                    fieldToDisplayOb: label,
                    isReferenceInputFieldVisible: true,
                    fieldToDisplayText:fieldValue.value,
                    referenceFieldToDisplayText:''
                });
            } else {
                const fieldToDisplayArray = this.utility.createObjectDeepCopy(this.state.fieldsToDisplay);
                const displayFields = this.utility.createObjectDeepCopy(this.state.displayFields);
                if (!this.state.isTextAreaSizeManual || this.state.fieldType !== 'textarea') {
                    if(!this.isDataAlreadyPresent(label, displayFields)) {
                        fieldToDisplayArray.push(fieldValue.name);
                        displayFields.push(label);
                    }
                }

                this.updateState({
                    referenceFieldArray: [],
                    fieldToDiaplayObjVal: '',
                    fieldToDisplayRefObj: '',
                    fieldsToDisplay: fieldToDisplayArray,
                    toggleFieldToDisplay: true,
                    isReferenceInputFieldVisible: false,
                    fieldToDisplayText:'',
                    referenceFieldToDisplayText:'',
                    displayFields,
                    inputBoxSize: 0,
                    isTextAreaSizeManual: false,
                });
            }
        }
    }



    /**
     *
     *
     * @private
     * @memberof GridComponentFieldsToDisplay
     */
    private referenceFieldToDisplay = (referenceField: any) => {
        if(typeof referenceField === 'string') {
            return;
        }
        const fieldToDisplayArray = this.utility.createObjectDeepCopy(this.state.fieldsToDisplay);
        const displayFields = this.utility.createObjectDeepCopy(this.state.displayFields);
        const fieldObj = this.state.fieldToDiaplayObjVal;
        const fieldToDisplayRefObj = this.state.fieldToDisplayRefObj;
        
        if(!this.isDataAlreadyPresent({ [this.state.fieldToDisplayOb]: this.getLabel(referenceField.label) }, displayFields)) {
            displayFields.push({ [this.state.fieldToDisplayOb]: this.getLabel(referenceField.label) });
            if (fieldToDisplayRefObj) {
                fieldToDisplayArray.push({ [fieldObj]: `${fieldToDisplayRefObj}.${referenceField.name}` });
            } else {
                fieldToDisplayArray.push({ [fieldObj]: `${referenceField.name}` });
            }
        }

        this.updateState({
            fieldsToDisplay: fieldToDisplayArray,
            toggleFieldToDisplay: true,
            displayFields,
            referenceFieldToDisplayText:'',
        });
    }

    /**
     *
     *
     * @private
     * @memberof GridComponentFieldsToDisplay
     */
    private removeFromFieldToDisplay = (field: any) => {
        const fieldToDisplayArray = this.utility.createObjectDeepCopy(this.state.fieldsToDisplay);
        const displayFields = this.utility.createObjectDeepCopy(this.state.displayFields);
        const index = fieldToDisplayArray.indexOf(field);
        const fieldToDisplayElement = fieldToDisplayArray.splice(index, 1);
        displayFields.splice(index, 1);
        this.updateState({
            fieldsToDisplay: fieldToDisplayArray,
            displayFields,
            toggleFieldToDisplay: fieldToDisplayArray.length > 0
        }, fieldToDisplayElement, () => this.props.setCustomComponent({...field, isDeleted: true}));
    }

    /**
     *
     *
     * @private
     * @memberof GridComponentFieldsToDisplay
     */
    private handleDragStart = (e: any, data: any) => {
        let fromField = JSON.stringify(data);
        e.dataTransfer.setData("dragContent", fromField);
    };



    /**
     *
     *
     * @private
     * @memberof GridComponentFieldsToDisplay
     */
    private handleDragOver = (event: any) => {
        event.preventDefault();
        return false;
    };

    /**
     *
     *
     * @private
     * @memberof GridComponentFieldsToDisplay
     */
    private handleDrop = (event: any, field: any) => {
        event.preventDefault();
        let fromField = JSON.parse(event.dataTransfer.getData("dragContent"));
        this.swapBoxes(fromField, field);
        return false;
    };

    /**
     *
     *
     * @private
     * @memberof GridComponentFieldsToDisplay
     */
    private swapBoxes = (fromField: any, toField: any) => {
        let fieldsToDisplay = this.utility.createObjectDeepCopy(this.state.fieldsToDisplay);
        let displayFields = this.utility.createObjectDeepCopy(this.state.displayFields);
        let formFieldIndex = 0;
        let toFieldIndex = 0;
        let fromDisplayField = {};
        let toDisplayField = {};
        for (let i = 0; i < fieldsToDisplay.length; i++) {
            if (JSON.stringify(fieldsToDisplay[i]) === JSON.stringify(fromField)) {
                formFieldIndex = i;
                fromDisplayField = displayFields[i];
            }
            if (JSON.stringify(fieldsToDisplay[i]) === JSON.stringify(toField)) {
                toFieldIndex = i;
                toDisplayField = displayFields[i];
            }
        }
        let filteredList = [...fieldsToDisplay];
        filteredList[formFieldIndex] = toField;
        filteredList[toFieldIndex] = fromField;
        displayFields[formFieldIndex] = toDisplayField;
        displayFields[toFieldIndex] = fromDisplayField;

        this.updateState({
            displayFields,
            fieldsToDisplay: filteredList,
        });
    };

}

export const GridComponentFieldsToDisplay = observer(GridFieldsToDisplay);